<div class="flex flex-col hierarchy">
  <ng-container *ngIf="hierarchyData.unmappeditems?.length">
    <ng-container *ngIf="!selectable">
      <h3>Unassigned Facilities</h3>
      <hr class="border-[3px] border-black mb-5" />
      <thera-client-side-list
        class="hierarchy"
        [rowData]="hierarchyData.unmappeditems"
        [hideGridLines]="true"
        [rowDragManaged]="true"
        [animateRows]="true"
        [rowDragText]="rowDragText"
        [columnDefs]="columnDefs"
        [draggableAndDroppable]="true"
        (rowAdded)="onRowAdded($event, null)"
      ></thera-client-side-list>
    </ng-container>
    <mat-expansion-panel
      *ngIf="selectable"
      [expanded]="true"
      class="!mb-1 !shadow-none !rounded-none"
    >
      <mat-expansion-panel-header>
        <mat-checkbox
          (click)="$event.stopPropagation(); checkUnmappedFacilities()"
          [checked]="unmappedChecked"
          [disableRipple]="true"
          [disabled]="disabled"
          >Unmapped Facilities</mat-checkbox
        >
      </mat-expansion-panel-header>
      <ng-container>
        <div
          class="flex flex-row ml-5"
          *ngFor="let item of hierarchyData.unmappeditems; trackBy: itemTrackBy"
        >
          <mat-checkbox
            [checked]="item.checked"
            (click)="onCheck(item, !item.checked)"
            [disableRipple]="true"
            [disabled]="disabled"
            >{{ item.facilityname }}</mat-checkbox
          >
        </div>
      </ng-container>
      <ng-template #table> </ng-template>
    </mat-expansion-panel>
  </ng-container>
  <ng-container *ngIf="hierarchyData.hierarchies?.length">
    <ng-container *ngIf="!selectable">
      <h3 class="mt-5">Assigned Facilities</h3>
      <hr class="border-[3px] border-black mb-5" />
    </ng-container>
    <ng-container>
      <ng-container
        *ngTemplateOutlet="
          hierarchyTempl;
          context: {
            $implicit: hierarchyData.hierarchies,
            level: 1,
            parentLevel: null
          }
        "
      ></ng-container>
    </ng-container>
  </ng-container>
  <thera-button
    class="self-end"
    [config]="{
      text: 'Add Locations',
      variant: $any('PRIMARY_OUTLINE')
    }"
    *ngIf="
      showAddLocationsButton &&
      (hierarchyData.unmappeditems?.length || hierarchyData.hierarchies?.length)
    "
    (click)="onAddLocations()"
  ></thera-button>
</div>

<ng-template
  #hierarchyTempl
  let-hierarchies
  let-level="level"
  let-parentLevel="parentLevel"
>
  <ng-container *ngFor="let currentLevel of hierarchies; trackBy: levelTrackBy">
    <mat-expansion-panel
      [expanded]="true"
      class="!mb-1 !shadow-none !rounded-none"
    >
      <mat-expansion-panel-header
        [class.!bg-dark_blue]="level === 1"
        [class.!bg-matisse]="level === 2"
        [class.!bg-light_green]="level === 3"
        [class.division]="level === 1"
        [class.area]="level === 2"
        [class.region]="level === 3"
      >
        <mat-checkbox
          *ngIf="selectable"
          [class.division]="level === 1"
          [class.area]="level === 2"
          [class.region]="level === 3"
          (click)="
            $event.stopPropagation();
            onCheck(currentLevel, !currentLevel?.checked)
          "          [checked]="currentLevel.checked"
          [disableRipple]="true"
          [disabled]="disabled"
          >{{ currentLevel.name }}</mat-checkbox
        >
        <div
          class="text-white flex flex-row justify-between w-full"
          *ngIf="!selectable"
        >
          <span>{{ currentLevel.name }}</span>
          <div>
            <span
              (click)="$event.stopPropagation(); onAddLevel(currentLevel)"
              *ngIf="currentLevel.candaddchild"
              class="text-white mr-5"
              matTooltip="Add Child"
              ><i class="fa-solid fa-plus"></i
            ></span>
            <span
              (click)="$event.stopPropagation(); onEditLevel(currentLevel)"
              class="text-white mr-5"
              ><i class="fa-solid fa-pencil"></i
            ></span>
            <span
              (click)="$event.stopPropagation(); onDeleteLevel(currentLevel)"
              class="text-white mr-5"
              ><i class="fa-solid fa-trash"></i
            ></span>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div *ngIf="currentLevel?.levels">
        <ng-container
          *ngTemplateOutlet="
            hierarchyTempl;
            context: {
              $implicit: currentLevel?.levels,
              level: level + 1,
              parentLevel: currentLevel
            }
          "
        ></ng-container>
      </div>
      <div
        *ngIf="selectable && !tableSelect; else table"
        class="flex flex-col !ml-5"
      >
        <ng-container
          *ngFor="let item of currentLevel.items; trackBy: itemTrackBy"
        >
          <mat-checkbox
            [checked]="item.checked"
            (click)="onCheck(item, listCheckedFacilities ? !item.checked : !currentLevel?.checked)"
            [disableRipple]="true"
            [disabled]="item?.status === 'Disabled' || disabled"
            >{{ item.facilityname }}</mat-checkbox
          >
        </ng-container>
      </div>
      <ng-template #table>
        <ng-container *ngIf="tableSelect; else tableNoSelect">
          <div class="mt-3">
            <thera-client-side-list
              *ngIf="currentLevel?.items?.length"
              class="hierarchy mt-3"
              [rowData]="currentLevel.items"
              [hideGridLines]="true"
              [columnDefs]="columnDefs"
              [rowSelection]="rowSelection"
              (rowChecked)="onCheck($event.data, $event.node.selected)"
            ></thera-client-side-list>
          </div>
        </ng-container>
        <ng-template #tableNoSelect>
          <thera-client-side-list
            class="hierarchy"
            [rowData]="currentLevel.items"
            [hideGridLines]="true"
            [rowDragManaged]="true"
            [animateRows]="true"
            [rowDragText]="rowDragText"
            [columnDefs]="columnDefs"
            [dropZoneId]="currentLevel.id"
            [rowSelection]="rowSelection"
            [draggableAndDroppable]="
              currentLevel.canmovein && currentLevel.canmoveout
            "
            (rowAdded)="onRowAdded($event, currentLevel)"
          ></thera-client-side-list>
        </ng-template>
      </ng-template>
    </mat-expansion-panel>
  </ng-container>
  <mat-accordion> </mat-accordion>
</ng-template>
